// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorServerStub_container__fr-_Q","text":"ErrorServerStub_text__1NYvW","logo":"ErrorServerStub_logo__2X5es"};